import React, { useEffect } from 'react'
import { createContext, useContext, useState, ReactNode } from 'react'
import { ActivitysModel, FormsAdvances } from '../models/ScheduleModel'

// Define el modelo de datos para una tienda
interface StoreProps {
    _id: string
    schedule_id: string
    name: string
    code: string
    address: string
    campaign_status?: number
    distance?: number
    lat?: string
    lng?: string
    forms_relevant?: ActivitysModel[]
    forms?: string[]
    forms_advances?: FormsAdvances[]
    forms_featured?: ActivitysModel[]
    segment?: string
}

// Define el valor del contexto
interface StoreContextValue {
    stores: StoreProps[]
    allStores: StoreProps[]
    setStores: React.Dispatch<React.SetStateAction<StoreProps[]>>
    setAllStores: React.Dispatch<React.SetStateAction<StoreProps[]>>
    updateStoreStatus: (storeId: string, status: number) => void
    setReloadFormsFn: () => void
    reloadForms: boolean
}

// Define los props del proveedor de contexto
interface StoreContextProviderProps {
    children: ReactNode
}

const StoreContext = createContext<StoreContextValue | undefined>(undefined)

export const StoreContextProvider = ({ children }: StoreContextProviderProps) => {
    //set de tiendas
    const [stores, setStores] = useState<StoreProps[]>([])
    const [allStores, setAllStores] = useState<StoreProps[]>([])
    const [reloadForms, setReloadForms] = useState(false)

    const updateStoreStatus = (storeId: string, status: number) => {
        try {
            setStores((prevStores) => prevStores.map((store) => (store._id === storeId ? { ...store, campaign_status: status } : store)))
        } catch (error) {
            console.log(error)
        } finally {
            return
        }
    }

    const setReloadFormsFn = () => {
        setReloadForms(!reloadForms)
    }

    const value: StoreContextValue = {
        stores,
        setStores,
        updateStoreStatus,
        setAllStores,
        allStores,
        setReloadFormsFn,
        reloadForms,
    }

    return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>
}

export const useStoreContext = (): StoreContextValue => {
    const context = useContext(StoreContext)
    if (!context) {
        throw new Error('useStoreContext must be used within a StoreContextProvider')
    }
    return context
}
